import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { LoadingScreen } from '@/components/common/feedback/LoadingScreen'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  // Also check localStorage directly as a fallback during hydration
  const localStorageAuth = localStorage.getItem('auth-storage')
  let hasUserInStorage = false
  try {
    if (localStorageAuth) {
      const parsed = JSON.parse(localStorageAuth)
      hasUserInStorage = !!parsed?.state?.user
    }
  } catch (e) {
    // Invalid JSON, ignore
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  // Check both zustand state AND localStorage as fallback
  if (!isAuthenticated && !hasUserInStorage) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  // If user is in localStorage but not in store yet, show loading
  if (!isAuthenticated && hasUserInStorage) {
    return <LoadingScreen />
  }

  return <>{children}</>
}

